/**
 * メタフィールド連動バリエーションコレクション切り替え（PC スクロールボタン付き版）- v14
 * PC表示で1行4つ表示、見切れる場合はスクロールボタンを追加
 */

(function() {
    'use strict';

    // 商品データを保持する変数
    let productData = null;

    // 初期化時に商品データを取得
    function initializeProductData() {
        // 商品ハンドルを取得
        const productHandle = window.location.pathname.split('/products/')[1];
        if (!productHandle) return;

        // 商品データを取得
        fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(data => {
                productData = data;
                console.log('Product data loaded:', data);
                
                // 初期選択バリエーションに対応するコレクションを表示
                const initialVariant = getInitialSelectedVariant();
                if (initialVariant) {
                    displayCollectionForVariant(initialVariant);
                }
            })
            .catch(error => {
                console.error('Error loading product data:', error);
            });
    }

    // 初期選択されているバリエーションを取得
    function getInitialSelectedVariant() {
        if (!productData || !productData.variants) return null;
        
        // URLパラメータからvariant IDを取得
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (variantId) {
            return productData.variants.find(v => v.id == variantId);
        }
        
        // デフォルトは最初のバリエーション
        return productData.variants[0];
    }

    // バリエーション変更イベントリスナー
    function setupVariantChangeListener() {
        // Shopifyの標準バリエーション変更イベント
        document.addEventListener('variant:change', function(event) {
            console.log('Variant changed via Shopify event:', event.detail);
            if (event.detail && event.detail.variant) {
                displayCollectionForVariant(event.detail.variant);
            }
        });
        
        // フォームの変更も監視（フォールバック）
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
            form.addEventListener('change', function() {
                setTimeout(() => {
                    const selectedVariant = getCurrentSelectedVariant();
                    if (selectedVariant) {
                        console.log('Variant changed via form:', selectedVariant);
                        displayCollectionForVariant(selectedVariant);
                    }
                }, 100);
            });
        }
    }

    // 現在選択されているバリエーションを取得
    function getCurrentSelectedVariant() {
        if (!productData) return null;

        const form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return null;

        const variantIdInput = form.querySelector('input[name="id"], select[name="id"]');
        if (variantIdInput && variantIdInput.value) {
            return productData.variants.find(v => v.id == variantIdInput.value);
        }

        return null;
    }

    // バリエーションに対応するコレクションを表示
    function displayCollectionForVariant(variant) {
        console.log('Displaying collections for variant:', variant);

        // 1段目：collections_handle
        const collectionHandle1 = getCollectionHandleFromVariant(variant, 'collections_handle');
        if (!collectionHandle1) {
            console.log('No collection handle found for variant:', variant.id);
            hideCollectionDisplay('variant-collection-display');
        } else {
            console.log('Collection handle found:', collectionHandle1);
            showCollectionSection('variant-collection-display');
            loadAndDisplayCollection(collectionHandle1, 'variant-collection-display', '1');
        }

        // 2段目：collections_handle_2
        const collectionHandle2 = getCollectionHandleFromVariant(variant, 'collections_handle_2');
        if (!collectionHandle2) {
            console.log('No collection handle 2 found for variant:', variant.id);
            hideCollectionDisplay('variant-collection-display-2');
        } else {
            console.log('Collection handle 2 found:', collectionHandle2);
            showCollectionSection('variant-collection-display-2');
            loadAndDisplayCollection(collectionHandle2, 'variant-collection-display-2', '2');
        }

        const targetSku = variant.sku;
        const url = 'https://trinity-ec-site-com.myshopify.com/api/2026-04/graphql.json';
        const graphqlQuery = {
            query: `{ 
                products(first: 5, query: "tag:${targetSku} AND collection:outlet") { 
                    edges { 
                        node { 
                            id 
                            title 
                            handle 
                            tags 
                            collections(first: 100) {
                                edges {
                                    node {
                                    id
                                    title
                                    handle
                                    }
                                }
                            }
                        } 
                    } 
                } 
            }`
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(graphqlQuery) // オブジェクトをJSON文字列に変換
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTPエラー! ステータス: ${response.status}`);
            }
            return response.json(); // レスポンスをJSONとして解析
        })
        .then(result => {
            const allProducts = result?.data?.products?.edges || [];
            const outletProducts = allProducts.filter(item => {
                const productCollections = item.node.collections?.edges || [];
                return productCollections.some(col => col.node.handle === "outlet");
            });      

            const bannerElement = document.getElementById('outletBanner');
            const linkElements = document.querySelectorAll('.js-outlet-link');
            
            if (outletProducts.length >= 1) {
                bannerElement.style.display = 'block';
                const firstProductHandle = outletProducts[0].node.handle;
                const productUrl = `/products/${firstProductHandle}`;                
                linkElements.forEach(link => {
                    link.href = productUrl;
                });

            } else {
                bannerElement.style.display = 'none';
            }            
        })
        .catch(error => {
            console.error('データ取得中にエラーが発生しました:', error);
        });        

    }

    // パンくずからコレクションハンドルを取得
    function getCollectionHandleFromBreadcrumb() {
        // パンくずの2番目のリンク要素を探す
        const breadcrumbLinks = document.querySelectorAll('.breadcrumb__item .breadcrumb__link');
        
        if (breadcrumbLinks.length >= 2) {
            // 2番目のリンクのhref属性を取得
            const secondLink = breadcrumbLinks[1];
            const href = secondLink.getAttribute('href');
            
            if (href && href.includes('/collections/')) {
                // /collections/以降の部分を抽出
                const match = href.match(/\/collections\/([^\/]+)/);
                if (match && match[1]) {
                    const handle = match[1];
                    console.log('Collection handle from breadcrumb:', handle);
                    return handle;
                }
            }
        }
        
        console.log('No collection handle found in breadcrumb');
        return null;
    }

    // バリエーションのメタフィールドからコレクションハンドルを取得
    function getCollectionHandleFromVariant(variant, fieldName) {
        // まずメタフィールドから取得を試みる（レコメンドカラムを優先）
        if (window.variantMetafields && window.variantMetafields[variant.id]) {
            const metafieldHandle = window.variantMetafields[variant.id][fieldName];
            if (metafieldHandle) {
                console.log(`Metafield ${fieldName} for variant ${variant.id}:`, metafieldHandle);
                return metafieldHandle;
            }
        }
        
        // メタフィールドに登録がない場合、パンくずから取得
        const breadcrumbHandle = getCollectionHandleFromBreadcrumb();
        
        if (breadcrumbHandle) {
            // 1段目はそのまま使用
            if (fieldName === 'collections_handle') {
                console.log('Using breadcrumb handle for collections_handle:', breadcrumbHandle);
                return breadcrumbHandle;
            }
            // 2段目は-otherを追加
            else if (fieldName === 'collections_handle_2') {
                let modifiedHandle;
                // 既に-caseで終わっている場合は、-caseを-other-caseに置換
                if (breadcrumbHandle.endsWith('-case')) {
                    modifiedHandle = breadcrumbHandle.replace(/-case$/, '-other-case');
                }
                // 既に-filmで終わっている場合は、-filmを-other-filmに置換
                else if (breadcrumbHandle.endsWith('-film')) {
                    modifiedHandle = breadcrumbHandle.replace(/-film$/, '-other-film');
                }
                // 既に-lensで終わっている場合は、-lensを-other-lensに置換
                else if (breadcrumbHandle.endsWith('-lens')) {
                    modifiedHandle = breadcrumbHandle.replace(/-lens$/, '-other-lens');
                }
                // それ以外の場合は-otherを追加
                else {
                    modifiedHandle = breadcrumbHandle + '-other';
                }
                console.log('Using modified breadcrumb handle for collections_handle_2:', modifiedHandle);
                return modifiedHandle;
            }
        }

        console.log(`No ${fieldName} data found for variant:`, variant.id);
        return null;
    }

// コレクションを読み込んで表示
function loadAndDisplayCollection(collectionHandle, containerId, row) {
    const container = getOrCreateCollectionContainer(containerId);

    // セクションを表示
    showCollectionSection(containerId);
    
    // ローディング状態を表示
    const existingContent = container.querySelector('.section__inner');
    if (existingContent) {
        const productList = existingContent.querySelector('.product-list__inner');
        if (productList) {
            productList.innerHTML = '<div class="loading">関連商品を読み込み中...</div>';
        }
    } else {
        container.innerHTML = '<div class="loading">関連商品を読み込み中...</div>';
    }
    container.style.display = 'block';

    // コレクションタイトルと商品を取得
    fetch(`/collections/${collectionHandle}.json`)
        .then(response => {
            if (!response.ok) {
                if (response.status === 404) {
                    throw new Error(`Collection not found: ${collectionHandle}`);
                }
                throw new Error(`Collection metadata error: ${collectionHandle}`);
            }
            return response.json();
        })
        .then(data => {
            const title = data.collection.title;
            const formattedTitle = formatCollectionTitle(title, row);
            // 次に商品取得
            return fetch(`/collections/${collectionHandle}/products.json?limit=10`)
                .then(response => {
                    if (!response.ok) {
                        if (response.status === 404) {
                            throw new Error(`Products not found for collection: ${collectionHandle}`);
                        }
                        throw new Error(`Products fetch error for collection: ${collectionHandle}`);
                    }
                    return response.json();
                })
                .then(productData => {
                    console.log(`Loaded ${productData.products.length} products from collection:`, collectionHandle);
                    displayCollectionProducts(productData.products, container, formattedTitle, containerId);
                });
        })
        .catch(error => {
            console.error('Error loading collection:', error);
            // 404エラー（コレクションが存在しない）の場合はセクション全体を非表示
            if (error.message.includes('not found')) {
                console.log(`Collection ${collectionHandle} not found, hiding section ${containerId}`);
                hideCollectionDisplay(containerId);
            } else {
                // その他のエラーの場合のみエラーメッセージを表示
                container.innerHTML = '<div class="error">関連商品の読み込みに失敗しました。</div>';
            }
        });
}
    // コレクションタイトルをレコメンド表示用に加工 
    function formatCollectionTitle(rawTitle, row) {
      const parts = rawTitle.trim().split(/\s+/);
      // 1段目の場合
      if (parts.length >= 2 && row == 1) {
          let type = parts.pop(); // 最後の単語を商品タイプ
          if (type == '全製品一覧') {
            type = '製品';
          }
          const model = parts.join(' '); // 残りは機種名
          return `${model} で人気の ${type} を見る`;
      }
      // 2段目の場合
      else if(row == 2){
        const cleanedTitle = rawTitle.replace(/（[^）]*）/g, '').trim();
        return `${cleanedTitle}`;
      }
      // 充電機器の場合
      else if(parts.length == 1 && row == 1){
        return `人気の ${parts[0]} を見る`;
      }
      return rawTitle; 
    }

    // コレクション商品を表示（PC用スクロールボタン付き）
    function displayCollectionProducts(products, container, title, containerId) {
        if (!products || products.length === 0) {
            container.innerHTML = '<div class="no-products">関連商品が見つかりませんでした。</div>';
            return;
        }

        // モバイルかどうかを判定
        const isMobile = window.innerWidth <= 999;
        const needsScrollButtons = !isMobile && products.length > 4;

        let html = `
            <div class="section__inner">
                <h2 class="h3 variant-collection-title">${title}</h2>
                <div class="product-list variant-product-grid ${needsScrollButtons ? 'has-scroll-buttons' : ''}" data-container-id="${containerId}">
                    ${needsScrollButtons ? `
                        <button class="scroll-button scroll-button--prev" aria-label="前へ" data-container="${containerId}">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                    ` : ''}
                    <div class="product-list__wrapper">
                        <div class="product-list__inner product-list__inner--grid" ${isMobile ? 'style="display: flex !important; flex-wrap: nowrap !important; overflow-x: auto !important; overflow-y: hidden !important; -webkit-overflow-scrolling: touch; gap: 16px; padding: 0 20px; scrollbar-width: none; -ms-overflow-style: none;"' : ''}>
        `;

        products.forEach(product => {
            const imageUrl = product.images && product.images[0] ? product.images[0].src : '';
            const price = product.variants && product.variants[0] ? 
                formatCollectionPrice(product.variants[0].price) : '';
            const available = product.variants && product.variants[0] ? product.variants[0].available : false;
            
            // 割引価格の計算（デモ用）
            const originalPrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
            const hasDiscount = originalPrice && originalPrice > product.variants[0].price;
            
            // 評価データ（デモ用）
            const rating = Math.floor(Math.random() * 2) + 3;
            const reviewCount = Math.floor(Math.random() * 20) + 5;
            
            // モバイル用のスタイル
            const mobileStyles = isMobile ? 'style="flex: 0 0 calc(50vw - 20px) !important; min-width: calc(50vw - 20px) !important; max-width: calc(50vw - 20px) !important;"' : '';
            
            html += `
                <div class="product-item variant-product-item" data-product-id="${product.id}" ${mobileStyles}>
                    <div class="product-item__inner">
                        <a href="/products/${product.handle}" class="product-item__image-wrapper">
                            ${imageUrl ? `
                                <div class="aspect-ratio" style="--aspect-ratio: 1">
                                    <img src="${imageUrl}" 
                                         alt="${product.title}" 
                                         class="product-item__primary-image"
                                         loading="lazy"
                                         sizes="(max-width: 740px) calc(50vw - 20px), calc(25vw - 24px)">
                                </div>
                            ` : `
                                <div class="product-item__placeholder">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="currentColor" opacity="0.1">
                                        <path d="M34.5 3v8.25h8.25v3h-8.25V22.5h-3v-8.25H23.25v-3h8.25V3h3zm6 19.5v19.125a3.375 3.375 0 01-3.375 3.375H7.875A3.375 3.375 0 014.5 41.625V12.375A3.375 3.375 0 017.875 9H27v3H7.875a.375.375 0 00-.375.375v29.25c0 .207.168.375.375.375h29.25a.375.375 0 00.375-.375V22.5h3zm-24.386 9.99l5.636-5.636 5.636 5.636 6.364-6.364a1.5 1.5 0 012.121 0l3.879 3.879V39H9V29.561l4.114-4.115a1.5 1.5 0 012.122 0l.878.879v6.165zm-.364-8.99a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm0-3a.75.75 0 100-1.5.75.75 0 000 1.5z"></path>
                                    </svg>
                                </div>
                            `}
                        </a>
                        
                        <div class="product-item__info">
                            <div class="product-item__vendor">
                                ${product.vendor || 'ブランド名'}
                            </div>
                            
                            <h3 class="product-item__title">
                                <a href="/products/${product.handle}" class="link">
                                    ${product.title}
                                </a>
                            </h3>
                            
  
                            <div class="product-item__price-list">
                                ${hasDiscount ? `
                                    <span class="price price--highlight">${price} (税込)</span>
                                    <span class="price price--compare">${formatCollectionPrice(originalPrice)} (税込)</span>
                                ` : `
                                    <span class="price">${price} (税込)</span>
                                `}
                            </div>
                        </div>
                    </div>
                </div>
            `;
        });

        html += `
                        </div>
                    </div>
                    ${needsScrollButtons ? `
                        <button class="scroll-button scroll-button--next" aria-label="次へ" data-container="${containerId}">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    ` : ''}
                </div>
            </div>
        `;

        container.innerHTML = html;

        // スクロールバーを非表示にするスタイルを追加
        if (isMobile) {
            const styleTag = document.createElement('style');
            styleTag.textContent = `
                .product-list__inner--grid::-webkit-scrollbar {
                    display: none !important;
                }
            `;
            container.appendChild(styleTag);
        }

        // イベントリスナーを追加
        attachEventListeners(container);

        // CSSスタイルを追加（一度だけ）
        addCollectionStyles();
        
        // PC用スクロールボタンのイベントを設定
        if (needsScrollButtons) {
            setupScrollButtons(container);
        }
    }

    // スクロールボタンの設定
    function setupScrollButtons(container) {
        const scrollContainer = container.querySelector('.product-list__inner');
        const prevButton = container.querySelector('.scroll-button--prev');
        const nextButton = container.querySelector('.scroll-button--next');
        
        if (!scrollContainer || !prevButton || !nextButton) return;
        
        // スクロール量を計算（アイテム幅 + gap）
        const itemWidth = scrollContainer.querySelector('.variant-product-item')?.offsetWidth || 250;
        const scrollAmount = itemWidth + 16; // アイテム幅 + gap
        
        // 初期状態の設定
        updateScrollButtons();
        
        // スクロールボタンのクリックイベント
        prevButton.addEventListener('click', () => {
            scrollContainer.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });
        
        nextButton.addEventListener('click', () => {
            scrollContainer.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });
        
        // スクロール時のボタン状態更新
        scrollContainer.addEventListener('scroll', updateScrollButtons);
        
        function updateScrollButtons() {
            const scrollLeft = scrollContainer.scrollLeft;
            const scrollWidth = scrollContainer.scrollWidth;
            const clientWidth = scrollContainer.clientWidth;
            
            // 左端に到達したら前ボタンを無効化
            if (scrollLeft <= 0) {
                prevButton.disabled = true;
                prevButton.classList.add('disabled');
            } else {
                prevButton.disabled = false;
                prevButton.classList.remove('disabled');
            }
            
            // 右端に到達したら次ボタンを無効化
            if (scrollLeft + clientWidth >= scrollWidth - 1) {
                nextButton.disabled = true;
                nextButton.classList.add('disabled');
            } else {
                nextButton.disabled = false;
                nextButton.classList.remove('disabled');
            }
        }
        
        // リサイズ時の再計算
        window.addEventListener('resize', () => {
            updateScrollButtons();
        });
    }

    // 星評価を生成（スクリーンショットのスタイル）
    function generateStarRating(rating) {
        const fullStars = Math.floor(rating);
        const emptyStars = 5 - fullStars;
        let starsHtml = '';

        // 塗りつぶされた星
        for (let i = 0; i < fullStars; i++) {
            starsHtml += '★';
        }
        
        // 空の星
        for (let i = 0; i < emptyStars; i++) {
            starsHtml += '☆';
        }

        return starsHtml;
    }

    // イベントリスナーを追加
    function attachEventListeners(container) {
        // 必要に応じて他のイベントリスナーを追加
    }

    // 価格をフォーマット
    function formatCollectionPrice(priceString) {
        let price = typeof priceString === 'string' ? parseFloat(priceString) : priceString;
        
        return new Intl.NumberFormat('ja-JP', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(price) + '円';
    }

    // コレクション表示コンテナを取得または作成
    function getOrCreateCollectionContainer(containerId) {
        console.log(`\n=== getOrCreateCollectionContainer called for: ${containerId} ===`);
        
        // 既存のコンテナをチェック
        let existingSection = document.querySelector(`.variant-collection-section[data-collection-container-id="${containerId}"]`);
        
        if (existingSection) {
            const container = existingSection.querySelector(`#${containerId}`);
            if (container) {
                console.log(`✓ Found existing section container: ${containerId}`);
                container.style.display = 'block';
                return container;
            }
        }
        
        console.log(`Creating new section for ${containerId}`);
        
        // 新しい独立セクションを作成
        const section = document.createElement('section');
        section.className = 'shopify-section variant-collection-section';
        section.setAttribute('data-section-type', 'variant-collection');
        section.setAttribute('data-collection-container-id', containerId);
        
        const container = document.createElement('div');
        container.id = containerId;
        container.className = 'container';
        container.style.display = 'none';
        
        section.appendChild(container);
        
        // 適切な位置に挿入
        insertIndependentSection(section, containerId);
        
        return container;
    }
    
    // 独立セクションを挿入
    function insertIndependentSection(section, containerId) {
        console.log(`Inserting section for ${containerId}...`);
        
        // Recently viewedセクションを探す
        const recentlyViewedSection = findRecentlyViewedSection();
        
        if (containerId === 'variant-collection-display') {
            // 1段目：Recently viewedセクションの前に挿入
            if (recentlyViewedSection) {
                recentlyViewedSection.parentNode.insertBefore(section, recentlyViewedSection);
                console.log('Inserted first collection section before Recently viewed section');
            } else {
                const main = document.querySelector('main') || document.body;
                main.appendChild(section);
                console.log('Inserted first collection section at the end of main');
            }
        } else if (containerId === 'variant-collection-display-2') {
            // 2段目：1段目の直後に挿入
            const firstSection = document.querySelector('.variant-collection-section[data-collection-container-id="variant-collection-display"]');
            if (firstSection && firstSection.nextElementSibling) {
                firstSection.parentNode.insertBefore(section, firstSection.nextElementSibling);
            } else if (recentlyViewedSection) {
                recentlyViewedSection.parentNode.insertBefore(section, recentlyViewedSection);
            } else {
                const main = document.querySelector('main') || document.body;
                main.appendChild(section);
            }
            console.log('Inserted second collection section');
        }
    }
    
    // Recently viewedセクションを探す
    function findRecentlyViewedSection() {
        console.log('Searching for Recently viewed section...');
        
        // 方法1: IDで探す
        const recentlyViewedById = document.querySelector('[id*="recently-viewed"], [id*="__recently-viewed"], [id*="recently_viewed"]');
        if (recentlyViewedById) {
            console.log('Found Recently viewed section by ID:', recentlyViewedById.id);
            return recentlyViewedById;
        }
        
        // 方法2: クラス名で探す
        const recentlyViewedByClass = document.querySelector('.recently-viewed-section, .recently-viewed, .recent-products');
        if (recentlyViewedByClass) {
            console.log('Found Recently viewed section by class');
            return recentlyViewedByClass;
        }
        
        // 方法3: テキスト内容で探す
        const sections = document.querySelectorAll('.shopify-section');
        for (const section of sections) {
            const headings = section.querySelectorAll('h2, h3, h4');
            for (const heading of headings) {
                const text = heading.textContent.toLowerCase();
                if (text.includes('recently viewed') || text.includes('最近表示した') || text.includes('最近見た')) {
                    console.log('Found Recently viewed section by heading text');
                    return section;
                }
            }
        }
        
        console.log('Recently viewed section not found');
        return null;
    }

    // コレクション表示を非表示
    function hideCollectionDisplay(containerId) {
        // コンテナを非表示
        const container = document.getElementById(containerId);
        if (container) {
            container.style.display = 'none';
        }
        
        // セクション全体も非表示
        const section = document.querySelector(`.variant-collection-section[data-collection-container-id="${containerId}"]`);
        if (section) {
            section.style.display = 'none';
        }
    }

    // CSSスタイルを追加（PC用スクロールボタン付き版）
    function addCollectionStyles() {
        if (document.getElementById('variant-collection-styles-pc-scroll')) return;

        const styles = `
            <style id="variant-collection-styles-pc-scroll">
                /* セクションの基本スタイル */
                .variant-collection-section {
                    padding: 32px 0;
                    background-color: #f5f5f5;
                    margin-bottom: 16px;
                    display: block;
                }
                
                /* セクションを非表示にする場合 */
                .variant-collection-section[style*="display: none"] {
                    margin-bottom: 0;
                }
                
                .variant-collection-section .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 40px;
                }
                
                /* タイトル */
                .variant-collection-section .variant-collection-title {
                    text-align: center;
                    margin-bottom: 24px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #333;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    line-height: 19px; 
                }
                
                /* 商品グリッド */
                .variant-collection-section .variant-product-grid {
                    position: relative;
                    width: 100%;
                }
                
                /* スクロールボタン付きレイアウト */
                .variant-collection-section .variant-product-grid.has-scroll-buttons {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }
                
                .variant-collection-section .product-list__wrapper {
                    flex: 1;
                    overflow: hidden;
                }
                
                /* PC表示: 1行4つ、横スクロール */
                @media screen and (min-width: 1000px) {
                    .variant-collection-section .product-list__inner--grid {
                        display: flex !important;
                        gap: 16px;
                        overflow-x: auto;
                        overflow-y: hidden;
                        scroll-behavior: smooth;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                    }
                    
                    .variant-collection-section .product-list__inner--grid::-webkit-scrollbar {
                        display: none;
                    }
                    
                    .variant-collection-section .variant-product-item {
                        flex: 0 0 calc(25% - 12px);
                        min-width: 0;
                        width: calc(25% - 12px);
                    }
                }
                
                /* スクロールボタン */
                .variant-collection-section .scroll-button {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 48px;
                    height: 48px;
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                }
                
                .variant-collection-section .scroll-button:hover:not(.disabled) {
                    background: #f5f5f5;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
                
                .variant-collection-section .scroll-button--prev {
                    left: -24px;
                }
                
                .variant-collection-section .scroll-button--next {
                    right: -24px;
                }
                
                .variant-collection-section .scroll-button.disabled {
                    opacity: 0.3;
                    cursor: not-allowed;
                }
                
                .variant-collection-section .scroll-button svg {
                    width: 20px;
                    height: 20px;
                    color: #333;
                }
                
                /* 商品アイテム */
                .variant-collection-section .product-item__inner {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                }
                
                /* 画像ラッパー */
                .variant-collection-section .product-item__image-wrapper {
                    position: relative;
                    display: block;
                    margin-bottom: 12px;
                    /* border-radius: 8px; */
                    overflow: hidden;
                    background: #f5f5f5;
                }
                
                /* 商品画像 */
                .variant-collection-section .aspect-ratio {
                    position: relative;
                    padding-bottom: 100%;
                }
                
                .variant-collection-section .product-item__primary-image {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                
                /* プレースホルダー */
                .variant-collection-section .product-item__placeholder {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    aspect-ratio: 1;
                    background: #f5f5f5;
                }
                
                /* 商品情報 */
                .variant-collection-section .product-item__info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    padding: 0 4px;
                }
                
                /* ベンダー名 */
                .variant-collection-section .product-item__vendor {
                    font-size: 12.6px;
                    color: #282828;
                    text-align: center;
                    line-height: 19.8px;
                    font-family: Montserrat;
                }
                
                /* 商品タイトル */
                .variant-collection-section .product-item__title {
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 1.3;
                    margin: 0;
                    text-align: center;
                }
                
                .variant-collection-section .product-item__title a {
                    color: #315086;
                    text-decoration: none;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    font-family: 'Noto Sans JP';
                    font-size: 12.6px;
                    font-weight: bold;
                }
                
                .variant-collection-section .product-item__title a:hover {
                    /*color: #000;*/
                }
                
                /* 評価 */
                .variant-collection-section .product-item__rating {
                    text-align: center;
                    margin: 2px 0;
                }
                
                .variant-collection-section .rating {
                    display: inline-flex;
                    align-items: center;
                    gap: 2px;
                    font-size: 11px;
                }
                
                .variant-collection-section .rating__stars {
                    color: #ffa500;
                    letter-spacing: 1px;
                    font-size: 13px;
                }
                
                .variant-collection-section .rating__caption {
                    color: #999;
                    font-size: 11px;
                }
                
                /* 価格 */
                .variant-collection-section .product-item__price-list {
                    text-align: center;
                    // margin-top: auto;
                    // padding-top: 4px;
                }
                
                .variant-collection-section .price {
                    font-size: 12.6px;
                    font-weight: 600;
                    color: #282828;
                    line-height: 18px;
                    font-family: "Noto Sans JP";
                    font-style: normal;
                }
                
                .variant-collection-section .price--highlight {
                    color: #e74c3c;
                }
                
                .variant-collection-section .price--compare {
                    font-size: 12px;
                    color: #999;
                    text-decoration: line-through;
                    font-weight: 400;
                    display: block;
                    line-height: 1.2;
                    margin-top: 2px;
                }
                
                /* タブレット対応 */
                @media screen and (min-width: 741px) and (max-width: 999px) {
                    .variant-collection-section .product-list__inner--grid {
                        display: grid !important;
                        grid-template-columns: repeat(3, 1fr);
                        gap: 20px;
                    }
                    
                    .variant-collection-section .scroll-button {
                        display: none;
                    }
                }
                
                /* モバイル対応 */
                @media screen and (max-width: 740px) {
                    .variant-collection-section .container {
                        padding: 0 20px;
                    }
                    
                    .variant-collection-section .product-list__inner--grid {
                        display: flex !important;
                        grid-template-columns: none !important;
                        overflow-x: auto !important;
                        overflow-y: hidden !important;
                        -webkit-overflow-scrolling: touch;
                        scroll-snap-type: x mandatory;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                    }
                    
                    .variant-collection-section .variant-product-item {
                        flex: 0 0 calc(50vw - 20px) !important;
                        scroll-snap-align: start;
                    }
                    
                    .variant-collection-section .product-item__vendor {
                        font-size: 12.6px;
                    }
                    
                    .variant-collection-section .product-item__title {
                        font-size: 12px;
                    }
                    
                    .variant-collection-section .price {
                        font-size: 13px;
                    }
                    
                    .variant-collection-section .price--compare {
                        font-size: 11px;
                    }
                    
                    .variant-collection-section .scroll-button {
                        display: none;
                    }
                }
                
                @media screen and (max-width: 480px) {
                    .variant-collection-section .variant-product-item {
                        flex: 0 0 calc(50vw - 16px) !important;
                    }
                }
            </style>
        `;
        
        document.head.insertAdjacentHTML('beforeend', styles);
    }

    // コレクションセクションを表示
    function showCollectionSection(containerId) {
        const section = document.querySelector(`.variant-collection-section[data-collection-container-id="${containerId}"]`);
        if (section) {
            section.style.display = 'block';
        }
    }

    // デバッグ情報を表示
    function debugMetafields() {
        console.log('=== Variant Metafields Debug ===');
        console.log('Available metafields:', window.variantMetafields);
        if (productData && productData.variants) {
            productData.variants.forEach(variant => {
                const metafield = window.variantMetafields ? window.variantMetafields[variant.id] : null;
                console.log(`Variant ${variant.id} (${variant.title}):`, metafield);
            });
        }
    }

    // 初期化
    function initialize() {
        console.log('Metafield variant collection switcher (PC Scroll v14) initializing...');
        
        // DOMが読み込み完了後に実行
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                setTimeout(() => {
                    initializeProductData();
                    setupVariantChangeListener();
                    debugMetafields();
                }, 500);
            });
        } else {
            setTimeout(() => {
                initializeProductData();
                setupVariantChangeListener();
                debugMetafields();
            }, 500);
        }
    }

    // 初期化実行
    initialize();

    // デバッグ用にグローバルに公開
    window.variantCollectionPCScrollDebug = {
        productData,
        debugMetafields,
        getCurrentSelectedVariant,
        displayCollectionForVariant
    };

    console.log('Metafield variant collection switcher (PC Scroll v14) loaded');
})();